import { useEffect, useState } from 'react';
import Select from 'react-select';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import { GetScanningElementList } from '../../../../store/FLEET/FleetScan/fleetScanSlice';
import { useFormik } from 'formik';
import Breadcrumb from '../../../../components/Shared/Breadcrumb';
import { Card, CardBody, CardHeader } from '../../../../components/card/card';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { AddFleetInspectionSchema } from '../../../ValidationForm/validationSchema';
import { AddPeriodicallyScanning } from '../../../../store/FLEET/EquipmentInspection/equipmentInspectionSlice';
import CustomAlert from '../../../../components/Shared/Alert/CustomAlert';
import { useNavigate, useParams } from 'react-router-dom';
import useGetEquipmentsList from '../../../../hooks/FLeet/useGetEquipmentsList';
import Loading from '../../../../components/Shared/Loader/Loading';
import Button from 'react-bootstrap/Button';
import PopoverCustom from '@components/Shared/Popover/PopoverCustom';

import Kuroki from '../Kuroki';
import FileUpload from '@components/Files/FileUpload';
import useGetPeoplesList from '@hooks/NTX/useGetPeoplesList';
import useLookupFleetInspectionType from '@hooks/Lookups/use-Lookup-FleetInspectionType';

const AddScan = () => {
  const [attachments, setAttachments] = useState<File[]>([]);

  const Navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const { FleetInspectionTypeOptions } = useLookupFleetInspectionType();

  const { fleetEquipmentsId, lookupType } = useParams();
  const { OptionsDrivers } = useGetPeoplesList({ LookupType: '' });

  const { EquipmentsList, OptionsEquipments } = useGetEquipmentsList();
  const { ScanElementList, loading } = useAppSelector(state => state.FleetScan);
  const EquipmentData = EquipmentsList?.find(f => f.id === fleetEquipmentsId);
  useEffect(() => {
    dispatch(GetScanningElementList({ modelId: EquipmentData?.fleetModelId, lookupType: lookupType || '' }));
  }, [dispatch, EquipmentData]);

  const formik = useFormik({
    initialValues: {
      fleetEquipmentsId: fleetEquipmentsId,
      // driverId: 'b5e62c33-560b-4c7a-a4ce-08dbe89e0ef4',
      driverId: EquipmentData?.peopleId,
      scanningCode: '',
      odometer: 0,
      lookupType: lookupType,
      // scanningDate: date,
      scanningDate: new Date().toISOString().split('T')[0], // Set to today's date
      description: '',
      attachments: [],
      isAddAttach: false,
      details: ScanElementList?.scanningElements?.map(item => ({
        // scanningMasterId: null,
        scanningElementId: item.id,
        value: '',
        description: ''
      })),
      markers: [
        // {
        //   xPosition: '',
        //   yPosition: '',
        //   shape: '',
        //   color: '',
        //   comment: '',
        //   size: ''
        // }
      ]
    },
    enableReinitialize: true,
    validationSchema: AddFleetInspectionSchema(t),
    onSubmit: values => {
      const formData = new FormData();
      formData.append('FleetEquipmentsId', fleetEquipmentsId?.toString() ?? '');
      formData.append('Odometer', values.odometer?.toString() || '');
      formData.append('DriverId', values.driverId || '');
      formData.append('LookupType', values.lookupType || '');
      formData.append('ScanningCode', values.scanningCode || '');
      formData.append('ScanningDate', values.scanningDate || '');
      formData.append('Description', values.description || '');

      // Append details to formData
      values.details.forEach((detail, index) => {
        formData.append(`Details[${index}].scanningElementId`, detail.scanningElementId);
        // formData.append(`Details[${index}].value`, detail.value);
        formData.append(`Details[${index}].Value`, detail.value === '1' ? 'true' : 'false');

        formData.append(`Details[${index}].description`, detail.description);
      });

      // Append Markers to formData
      values.markers.forEach((marker: any, index) => {
        formData.append(`Markers[${index}].xPosition`, marker.x?.toString() ?? '');
        formData.append(`Markers[${index}].yPosition`, marker.y?.toString() ?? '');
        formData.append(`Markers[${index}].shape`, marker.shape ?? '');
        formData.append(`Markers[${index}].color`, marker.color ?? '');
        formData.append(`Markers[${index}].comment`, marker.comment ?? '');
        formData.append(`Markers[${index}].size`, marker.size?.toString() ?? '');
      });

      formData.append('IsAddAttach', values.isAddAttach ? 'true' : 'false');

      // رفع المرفقات
      if (values.attachments && values.attachments.length > 0) {
        values.attachments.forEach(file => {
          formData.append('Attach', file); // file من نوع File أو Blob
        });
      }

      dispatch(AddPeriodicallyScanning(formData))
        .unwrap()
        .then(res => {
          if (res?.succeeded === true) {
            formik.resetForm();
            CustomAlert({ action: 'Add' });
            Navigate('/FLEET/EquipmentInspection', { replace: true });
          } else {
            formik.setSubmitting(false);
            CustomAlert({ action: 'Error', msg: res?.message });
          }
        })
        .catch((error: any) => {
          formik.setSubmitting(false);
          CustomAlert({ action: 'Error' });
        });
    }
  });

  const handleAttachments: React.Dispatch<React.SetStateAction<File[]>> = value => {
    setAttachments(prev => {
      const newAttachments = typeof value === 'function' ? value(prev) : value;
      if (newAttachments.length > 0) {
        formik.setFieldValue('attachments', newAttachments);
        formik.setFieldValue('isAddAttach', true);
      } else {
        formik.setFieldValue('attachments', []);
        formik.setFieldValue('isAddAttach', false);
      }
      return newAttachments;
    });
  };

  return (
    <>
      <div className='d-flex align-items-center'>
        <Breadcrumb
          BreadcrumbList={[
            { name: 'Home',link: ':moduleHome' },
            { name: 'EquipmentInspection', link: '/FLEET/EquipmentInspection' },
            { name: 'NewScan', link: null }
          ]}
          PageName='NewScan'
          subtitle={
            (i18n.language === 'ar' ? EquipmentData?.name2 : EquipmentData?.name) +
            ' | ' +
            (FleetInspectionTypeOptions?.find((f: any) => f.value === lookupType)?.label || '')
          }
        />
        <div className='ms-auto'></div>
      </div>

      <Loading loading={loading}>
        <CardBody className=''>
          <Form onSubmit={formik.handleSubmit}>
            {/* Equipment Info Section   */}
            <div
              className='row mb-4 '
              style={{
                backgroundColor: 'var(--bs-card-bg)',
                zIndex: 10,
                paddingTop: '10px',
                paddingBottom: '10px',
                boxShadow: '0 5px 4px rgba(0,0,0,0.1)'
              }}
            >
              <div className='col-md-12 mb-3'>
                <Card className='h-100 '>
                  <CardBody>
                    <div className='row'>
                      <div className='col-md-12'>
                        <div className='input-group flex-nowrap'>
                          <span className='input-group-text bg-theme text-white fw-bold'>
                            <i className='fas fa-car-side me-2'></i>
                            {t('Vehicle')}
                          </span>
                          <Select
                            isDisabled
                            classNamePrefix='react-select'
                            className='w-100  '
                            isLoading={loading}
                            isSearchable={true}
                            isClearable
                            options={OptionsEquipments.filter(f => !f.IsVacant)}
                            value={OptionsEquipments.find(f => f.value === fleetEquipmentsId)}
                            placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                            formatOptionLabel={option => {
                              const isRTL = i18n.language === 'ar';
                              const imgSrc = option.PathImage || '/assets/img/Image/NoImg2.ico';

                              return (
                                <div className='d-flex justify-content-between align-items-center'>
                                  <div className='d-flex align-items-center'>
                                    <img
                                      src={imgSrc}
                                      alt={option.label}
                                      onError={(e: any) => {
                                        e.target.onerror = null;
                                        e.target.src = '/assets/img/Image/NoImg2.ico';
                                      }}
                                      style={{
                                        width: '40px',
                                        height: '40px',
                                        objectFit: 'cover',
                                        marginLeft: isRTL ? '10px' : '0',
                                        marginRight: isRTL ? '0' : '10px',
                                        borderRadius: '4px'
                                      }}
                                    />
                                    <div>{option.label}</div>
                                  </div>
                                  {/* <span className='fw-bold badge border border-theme text-theme px-2 pt-5px pb-5px rounded fs-12px d-inline-flex align-items-center'>
                                    <i className='bi bi-person-fill fs-18px fa-fw me-5px'></i>
                                    {option.deiverName}
                                  </span> */}
                                </div>
                              );
                            }}
                          />
                        </div>
                      </div>

                      <div className='col-md-4 mt-3'>
                        <div className='input-group flex-nowrap'>
                          <span className='input-group-text bg-theme text-white fw-bold'>
                            <i className='fas fa-user fa-lg	 me-2'></i>
                            {t('Driver')}
                          </span>
                          <Select
                            isDisabled
                            classNamePrefix='react-select'
                            className='w-100  '
                            isLoading={loading}
                            isSearchable={true}
                            isClearable
                            options={OptionsDrivers}
                            value={OptionsDrivers.find(f => f.value === EquipmentData?.peopleId)}
                            placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                          />
                        </div>
                      </div>

                      <div className='col-md-4 mt-3'>
                        <div className='input-group flex-nowrap'>
                          <span className='input-group-text bg-theme text-white fw-bold'>
                            <i className=' fa-fw bi bi-speedometer fa-lg	 me-2'></i>
                            {t('Odometer')}
                          </span>
                          <Form.Control
                            type='number'
                            name='odometer'
                            value={formik.values.odometer}
                            onChange={formik.handleChange}
                            className='form-control-lg'
                          />
                        </div>
                      </div>
                      <div className='col-md-4 mt-3'>
                        <div className='input-group flex-nowrap'>
                          <span className='input-group-text bg-theme text-white fw-bold'>
                            <i className='far fa-calendar-alt fa-lg me-2'></i>
                            {t('InspectionDate')}
                          </span>
                          <Form.Control
                            // type='datetime-local'
                            type='date'
                            name='scanningDate'
                            value={formik.values.scanningDate}
                            onChange={formik.handleChange}
                            className='form-control-lg'
                          />
                        </div>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </div>
            </div>

            {/* Inspection Items Section */}
            <Card className='mb-4'>
              <CardHeader className='bg-theme bg-opacity-25 text-white'>
                <h5 className='mb-0'>
                  <i className='fas fa-clipboard-list me-2'></i>
                  {t('InspectionList')}
                </h5>
              </CardHeader>
              <CardBody>
                {/* {ScanElementList &&
                  formik.values.details &&
                  ScanElementList?.scanningElements?.map((item, index) => {
                    const detail = formik.values.details[index];
                    return (
                      <div
                        key={index}
                        className='row mb-2 bg-inverse bg-opacity-10 rounded-2 p-1 mx-2 border  hover-highlight'
                      >
                        <div className='col-md-4 col-lg-2 fw-bold'>
                          {i18n.language === 'en' ? item.name : item.name2}
                        </div>
                        <div className='col-md-6 col-lg-7'>
                          {i18n.language === 'en' ? item.description : item.description2}
                        </div>

                        <div className='col-md-4 col-lg-3 bg-theme bg-opacity-5 rounded-0 text-center'>
                          <ButtonGroup className='w-100'>
                            {radios.map((radio, idx) => (
                              <ToggleButton
                                className='flex-grow-1 d-flex align-items-center justify-content-center'
                                key={idx}
                                id={`radio-${index}-${idx}`}
                                type='radio'
                                variant={radio.value ? 'outline-success' : 'outline-danger'}
                                name={`details[${index}].value`}
                                value={radio.value ? '1' : '0'}
                                checked={detail?.value === (radio.value ? '1' : '0')}
                                onChange={() =>
                                  formik.setFieldValue(`details[${index}].value`, radio.value ? '1' : '0')
                                }
                              >
                                {radio.value ? (
                                  <i className='fas fa-check me-2'></i>
                                ) : (
                                  <i className='fas fa-times me-2'></i>
                                )}
                                {radio.name}
                              </ToggleButton>
                            ))}
                          </ButtonGroup>
                        </div>
                      </div>
                    );
                  })} */}

                <div className='row'>
                  {ScanElementList &&
                    formik.values.details &&
                    ScanElementList.scanningElements.map((item, index) => {
                      const detail = formik.values.details[index];

                      return (
                        <div key={index} className='col-md-4 mb-2'>
                          <div className='bg-inverse bg-opacity-10 rounded-2 p-2 border hover-highlight d-flex justify-content-between'>
                            <div className='fw-bold mb-0'>
                              <span className='me-2 text-theme '>{index + 1}.</span>
                              {i18n.language === 'en' ? item.name : item.name2}

                              {item.description && (
                                <PopoverCustom
                                  childern={<i className='fas fa-info-circle ms-2'></i>}
                                  Body={i18n.language === 'en' ? item.description : item.description2}
                                />
                              )}
                            </div>

                            <div className='text-center d-flex gap-2 justify-content-center'>
                              <Button
                                variant={detail?.value === '1' ? 'success' : 'outline-success'}
                                onClick={() => formik.setFieldValue(`details[${index}].value`, '1')}
                              >
                                <i className='fas fa-check '></i>
                              </Button>

                              <Button
                                variant={detail?.value === '0' ? 'danger' : 'outline-danger'}
                                onClick={() => formik.setFieldValue(`details[${index}].value`, '0')}
                              >
                                <i className='fas fa-times'></i>
                              </Button>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                </div>

                <style>
                  {`
                      .hover-highlight {
                        transition: background-color 0.3s ease, box-shadow 0.3s ease;
                      }
                    .hover-highlight:hover {
                     background-color: rgba(var(--bs-theme-rgb), 0.2) !important;
                     box-shadow: 0 0 5px rgba(0, 123, 255, 0.4);
                     cursor: pointer;
                    }

                      `}
                </style>
              </CardBody>
            </Card>

            {/* Diagram Section */}
            {ScanElementList?.kuroki && (
              <Card className='mb-4'>
                <CardHeader className='bg-theme bg-opacity-25 text-white'>
                  <h5 className='mb-0'>
                    <i className='fas fa-image me-2'></i>
                    {t('VehicleDiagram')}
                  </h5>
                </CardHeader>
                <CardBody>
                  <Kuroki formik={formik} KurokiImage={ScanElementList.kuroki.filePath ?? ''} />
                </CardBody>
              </Card>
            )}

            {/* Notes & Attachments Section */}
            <div className='row mb-2'>
              <div className='col-md-6 mb-3'>
                <Card className='h-100'>
                  <CardHeader className='bg-theme bg-opacity-25 text-white'>
                    <h5 className='mb-0'>
                      <i className='fas fa-edit me-2'></i>
                      {t('Notes')}
                    </h5>
                  </CardHeader>
                  <CardBody>
                    <Form.Control
                      as='textarea'
                      rows={5}
                      name='description'
                      value={formik.values.description}
                      onChange={formik.handleChange}
                      placeholder={t('AddYourNotesHere')}
                      className='h-100'
                    />
                  </CardBody>
                </Card>
              </div>

              <div className='col-md-6 mb-3'>
                <Card className='h-100'>
                  <CardHeader className='bg-theme bg-opacity-25 text-white'>
                    <h5 className='mb-0'>
                      <i className='fas fa-paperclip me-2'></i>
                      {t('المرفقـات')}
                    </h5>
                  </CardHeader>
                  <CardBody>
                    <FileUpload attachments={attachments} setAttachments={handleAttachments} />
                  </CardBody>
                </Card>
              </div>
            </div>

            {/* Action Buttons */}
            {/* <div className='d-flex justify-content-center gap-3'>
              <button type='submit' className='btn btn-theme btn-lg px-4' disabled={formik.isSubmitting}>
                {formik.isSubmitting ? (
                  <>
                    <span className='spinner-border spinner-border-sm me-2'></span>
                    {t('Saving')}...
                  </>
                ) : (
                  <>
                    <i className='fas fa-save me-2'></i>
                    {t('Save')}
                  </>
                )}
              </button>

              <button type='button' className='btn btn-outline-secondary btn-lg px-4' onClick={() => Navigate(-1)}>
                <i className='fas fa-times me-2'></i>
                {t('Cancel')}
              </button>
            </div> */}

            <div className='d-flex justify-content-center gap-3 mt-1'>
              <button
                type='submit'
                className='btn btn-lg  btn-theme mb-1 w-100 rounded-0'
                disabled={formik.isSubmitting}
              >
                {formik.isSubmitting ? (
                  <>
                    <span className='spinner-border spinner-border-sm me-2'></span>
                    {t('Saving')}...
                  </>
                ) : (
                  <>
                    <i className='fas fa-save me-2'></i>
                    {t('Save')}
                  </>
                )}
              </button>

              <button
                type='button'
                className='btn btn-lg  btn-default mb-1 w-100 rounded-0'
                onClick={() => Navigate(-1)}
              >
                <i className='fas fa-times me-2'></i>
                {t('Cancel')}
              </button>
            </div>
          </Form>
        </CardBody>
      </Loading>
    </>
  );
};

export default AddScan;
